import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Activate({ api, messenger, setAccount }) {
  const navigate = useNavigate();
  const [activateParam] = useSearchParams();
  const token = activateParam.get("token");
  const email = activateParam.get("email");
  const [message, setMessage] = useState();
  const [timeRedirect, setTimeRedirect] = useState(5);

  useEffect(() => {
    if (!token && !email) {
      navigate("/");
    } else {
      api("api/auth/activate/", {
        method: "POST",
        ignoreError: true,
        ignoreForbidden: true,
        body: {
          email: email,
          token,
        },
      }).then(({ ok, body }) => {
        if (ok) {
          setMessage("Account successfully activated.");
          api(`api/providers/${process.env.REACT_APP_SLUG}/users/me/`).then(
            ({ body }) => {
              setAccount(body?.data);
              navigate("/");
            },
          );
        } else {
          if (body && body.status_code === "403") {
            setMessage(
              "To proceed with the login you must activate your account, click on the activation link sent to your email",
            );
          } else {
            navigate("/");
          }
        }
      });
    }
  }, [navigate, api, token, email, messenger, setAccount]);

  useEffect(() => {
    if (message) {
      let timeCount = 5;
      const countdownRedirect = setInterval(function () {
        if (timeCount < 0) {
          clearInterval(countdownRedirect);
          navigate("/");
        } else {
          setTimeRedirect(timeCount);
        }
        timeCount -= 1;
      }, 1000);
    }
  }, [message, navigate]);

  return (
    <div
      style={{
        display: "flex",
        height: "48vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {message ? (
        <div className="bw-event-container text-center">
          <h2 className="mb-4">{message}</h2>
          <p>
            You will be sent back to the home page in {timeRedirect} second
            {timeRedirect > 0 ? "s" : ""}
          </p>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
